import React from 'react'
import {Icon} from 'components/Icons'
import {SignatureContainer} from './style'

export const BeksinskiSignature = ({light,active})=>(
    <SignatureContainer>
        <Icon type='signature' width='120px' color={light&&!active?'black':'white'}/>
    </SignatureContainer>
)
